import Vue from 'vue';
import Vuex from 'vuex';
import http from "@utils/request";
import _cloneDeep from "lodash/cloneDeep";

/** 引入模块 */
import Simulation from "@pages/simulation/store";

// 计费模块
import Bill from "./bill";

Vue.use(Vuex)

export default new Vuex.Store({
  modules:{
    simulation:Simulation,
    bill:Bill
  },
  state: {
    token: "",
    selectSites: [], // 选择的站点编号
    configList: null, //getconfig接口数据
    db:null,  // 当前选中的数据库信息
    dblist:null, // 可选数据库列表
    user:null, // 用户信息
    sites_config:null, // 站点信息数据，包括分组、groupList、mediumList、siteList
    sitesConfig:{}, // 根据不同的页面返回不同的站点配置信息
    userFreeSettings:{}, // 用户个人全局配置
    assetsUrl:window.location.protocol+'//' + window.location.host, // 静态资源的地址
  },
  mutations: {
    // 登录凭证
    token: (state, token) => {
      state.token = token;
      // 保存token
      sessionStorage.setItem("token", token);

      // 设置全局请求参数
      http.setDefault({
        token: token
      });
    },
    // 选择的站点
    selectSites: (state, sites) => {
      state.selectSites = sites;
    },
    //用户配置信息
    configList: (state, params) => {
      state.configList = params;
      sessionStorage.setItem("configList", JSON.stringify(state.configList))
    },
    // 数据库配置信息
    db: (state, db) => {
      state.db = db;
      sessionStorage.setItem("db", JSON.stringify(db))
    },
    // 可选数据库列表
    dblist: (state, dblist) => {
      state.dblist = dblist;
      sessionStorage.setItem("dblist", JSON.stringify(dblist))
    },
    //用户配置信息
    user: (state, user) => {
      state.user = user;
      sessionStorage.setItem("user", JSON.stringify(user))
    },
    // 设置通用站点配置信息
    sites_config:(state,sites_config)=>{
      state.sites_config = Object.assign({},sites_config||{});
      let time=new Date().getTime();
      state.sites_config["-"]=time;
      sessionStorage.setItem("sites_config", JSON.stringify(sites_config));

      // 清空配置
      state.sitesConfig={}
    },
    /**
     * 设置不同页面的站点选择配置
     * @param {*} state 
     * @param {*} sites_config 
     */
    sitesConfigPage:(state,sites_config)=>{
      let page="default";
      let config=sites_config;
      // 如果单独的配置页面，则配置的类型为{page:Object,config:Object}
      if(sites_config.page){
        page=sites_config.page;
        config=sites_config.config;
      }else{
        // 获取当前页面相关的站点配置
        let route=location.pathname;
        switch(true){
          case (route.indexOf("/list/realTimeChart")!=-1):
          case (route.indexOf("/list/realTimeForm")!=-1):
            page="realtime"
            break;
          case (route.indexOf("/list/historyForm")!=-1):
          case (route.indexOf("/list/historyChart")!=-1):
            page="history";
            break;
        }
      }
      
      state.sitesConfig=Object.assign({},state.sitesConfig,{
        [page]:config
      });
    },
    // 用户个人全局配置
    userFreeSettings:(state,userFreeSettings)=>{
      state.userFreeSettings = userFreeSettings;
      sessionStorage.setItem("usersreesettings", JSON.stringify(userFreeSettings))
    }
  },
  getters:{
    // 获取token
    token:state=>{
      let temp=state.token;
      if(!temp){
        try{
          let session=sessionStorage.getItem("token");
          temp=session;
          state.token=temp;
        }catch(err){
          console.log(err)
        }
      }
      if(!temp){
        temp="";
      }
      return temp;
    },
    // 获取用户信息
    user:state=>{
      let tempuser=state.user;
      if(!tempuser){
        try{
          let session=sessionStorage.getItem("user");
          tempuser=JSON.parse(session);
          state.user=tempuser;
        }catch(err){
          console.log(err)
        }
      }
      if(!tempuser){
        tempuser={};
      }
      return tempuser;
    },
    // 获取用户个人全局配置信息
    userFreeSettings:state=>{
      let tempuser=state.userFreeSettings;
      if(!tempuser){
        try{
          let session=sessionStorage.getItem("userfreesettings");
          tempuser=JSON.parse(session);
          state.user=tempuser;
        }catch(err){
          console.log(err)
        }
      }
      if(!tempuser){
        tempuser={};
      }
      return tempuser;
    },
    // 获取数据库信息
    db:state=>{
      let temp=state.db;
      if(!temp){
        try{
          let session=sessionStorage.getItem("db");
          temp=JSON.parse(session);
          state.db=temp;
        }catch(err){
          console.log(err);
        }
      }
      if(!temp){
        temp={};
      }
      return temp;
    },
    // 获取用户配置
    configList:state=>{
      let temp=state.configList;
      if(!temp){
        try{
          let session=sessionStorage.getItem("configList");
          temp=JSON.parse(session);
          state.configList=temp;
        }catch(err){
          console.log(err);
        }
      }
      if(!temp){
        temp={};
      }
      return temp;
    },
    // 获取通用站点配置
    sites_config:state=>{
      let temp=state.sites_config;
      // 如果站点配置不存在，则从SessionStore中获取
      if(!temp){
        try{
          let session=sessionStorage.getItem("sites_config");
          temp=JSON.parse(session);
          state.sites_config=temp;
        }catch(err){
          console.log(err);
        }
      }
      if(!temp){
        temp={};
      }
      return temp;
    },
    // 根据不同的页面获取不同的站点配置信息
    getSitesConfigByPage:(state)=>(pg)=>{
      // 获取当前页面相关的站点配置
      let route=location.pathname;
      let page=pg||"default";
      switch(route){
        case "/list/realTimeChart":
        case "/list/realTimeForm":
          page="realtime"
          break;
        case "/list/historyForm":
        case "/list/historyChart":
          page="history";
          break;
        case "/list/flow":
          page="flow";
          break;
      }
      // 获取特定页面的站点配置
      if(state.sitesConfig[page]){
        return state.sitesConfig[page];
      }else{
        let temp=state.sites_config;
        // 如果站点配置不存在，则从SessionStore中获取
        if(!temp){
          try{
            let session=sessionStorage.getItem("sites_config");
            temp=JSON.parse(session);
            state.sites_config=temp;
          }catch(err){
            console.log(err);
          }
        }
        if(!temp){
          temp={};
        }
        // 将该页面的站点配置进行深入的copy，避免其他页面的影响
        temp=_cloneDeep(temp);
        state.sitesConfig[page]=temp;
        return temp;
      }
    }
  },
  actions: {
    // 检查用户是否登录
    checklogin: (context) => {
      let token = context.state.token || sessionStorage.getItem("token");
      if (token && token != "undefined") {
        // 远程检查登录状态

        // 提交token
        context.commit("token", token);
        // 设置全局请求参数
        http.setDefault({
          token: token
        });
        return true;
      } else {
        sessionStorage.removeItem("token");
        // 跳转到登录页面
        location.href = window.location.protocol+'//' + window.location.host+ "/login";

      }
      return false;
    },
    // 同步获取用户配置数据以及站点数据配置
    async getUserConfig({dispatch}){
      return Promise.all([dispatch("getMediumConfig"),dispatch("getSitesConfig")]).catch(err=>{
        console.log(err);
      });
    },
    // 获取站点配置
    getMediumConfig({commit}){
      return http({//获取配置数据
          method: "POST",
          url: "/phemsjava/getConfig",
        }).then(res=>{
          // 保存用户配置
          if(res.medium_config){
            commit("configList",res);
          }
        })
    },
    // 获取站点配置
    getSitesConfig({commit}){
      return http({
          url: "/phemsjava/siteList"
        }).then(res=>{
          // 保存用户配置
          if(res.siteList){
            commit("sites_config",res);
          }
        })
    }
  }
})